import axios from 'axios';
import envService from "@/services/env.service";
import userService from "@/services/user.service";

const BASE_URL = envService.getApiBaseUrl() + '/devapps';

const SESSIONSTORAGE_DEVAPP_WEBID = "devAppWebId";
const SESSIONSTORAGE_DEVAPPS = "devApps_";
const SESSIONSTORAGE_DEVAPP = "devApp_";

export default {

    getCacheKey(email, role) {
        return SESSIONSTORAGE_DEVAPPS + "-" + email + "-" + role?.toUpperCase()
    },
    /** Get all subscriptions (DevApps) of user*/
    async getDevApps(role) {
        let email = await userService.getViewUserEmail()
        var devApps = [];
        var devAppsString = sessionStorage.getItem(this.getCacheKey(email, role));
        if (devAppsString === undefined || devAppsString === null) {
            let response = await axios.get(BASE_URL + '/' + role, {
                headers: {
                    'X-User-Email': email
                }
            });
            devApps = response.data;
            sessionStorage.setItem(this.getCacheKey(email, role), JSON.stringify(devApps));
        } else {
            devApps = JSON.parse(devAppsString)
        }
        return devApps;
    },
    /** Get choosen webId of DevApp */
    getDevAppWebId(role) {
        let sessionstorage_devAppWebId = sessionStorage.getItem(SESSIONSTORAGE_DEVAPP_WEBID + "-" + role.toUpperCase());
        if (sessionstorage_devAppWebId === undefined || sessionstorage_devAppWebId === null) {
            return undefined;
        } else {
            return sessionstorage_devAppWebId;
        }
    },
    /** Set choosen wenId of DevApp */
    setDevAppWebId(webId, role) {
        sessionStorage.setItem(SESSIONSTORAGE_DEVAPP_WEBID + "-" + role.toUpperCase(), webId);
    },

    setDevApp(key) {
        sessionStorage.setItem(SESSIONSTORAGE_DEVAPP, key);
    }
};
 